export default {
  base: {
    variant: 'spark.base.wrapper'
  },
  container: {
    base: {
      overflowX: 'auto',
      msOverflowStyle: 'none',
      // IE and Edge
      scrollbarWidth: 'none',
      // Firefox
      '::-webkit-scrollbar': {
        display: 'none' // Chrome, Safari and Opera

      }
    }
  },
  list: {
    base: {
      display: 'flex',
      alignItems: 'center',
      padding: 0,
      margin: 0,
      listStyle: 'none',
      whiteSpace: 'nowrap'
    }
  },
  listItem: {
    base: {
      display: 'flex',
      alignItems: 'center'
    }
  },
  link: {
    base: {
      mr: 7,
      outline: 'none',
      fontSize: ['xxxs', 'xxxs'],
      lineHeight: 'sm',
      ':not(:hover):not(:focus)': {
        color: 'grey-60'
      }
    },
    variants: {
      focus: {
        borderBottomColor: 'transparent'
      },
      last: {
        variant: 'spark.element.breadcrumbs.link.base',
        ':not(:hover):not(:focus)': {
          color: 'grey-100'
        }
      }
    }
  },
  separator: {
    base: {
      variant: 'spark.element.breadcrumbs.link.base',
      ':hover': {
        color: 'grey-60'
      }
    }
  }
};